import React, { Component } from "react";
import Order from "../../../containers/order";

export default class OrderView extends Component {
  render() {
    return <Order />;
  }
}



// WEBPACK FOOTER //
// ../shop_main/components/views/order/index.js